import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Card } from '@themesberg/react-bootstrap'
import { Context } from '../Cart'
import { getSummary, getUploadStatistic } from '../../../../controller/api/__loto__/cart'
import { useCookies } from 'react-cookie';

const StatCard = ({ title, value, variant = "primary", isCurrency = false }) => (
  <Card
    border="light"
    className={`shadow-sm h-100 border-0 border-start border-4 border-${variant}`}
    style={{ transition: "transform 0.2s" }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-3px)";
      e.currentTarget.className = e.currentTarget.className.replace("shadow-sm", "shadow");
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.className = e.currentTarget.className.replace("shadow", "shadow-sm");
    }}
  >
    <Card.Body className="py-3 px-4">
      <div className="text-muted small fw-bold text-uppercase mb-1">{title}</div>
      <h3 className={`fw-bold text-${variant} mb-0`}>
        {new Intl.NumberFormat("vi-VN").format(value)}{isCurrency ? "đ" : ""}
      </h3>
    </Card.Body>
  </Card>
);

const _Summary = () => {

  const { state } = useContext(Context);
  const isNewTab = state.activeTab === 'new'
  const isHasResultTab = state.activeTab === 'has_result'

  const [cookies] = useCookies(['lottmekong'])

  const [summary, setSummary] = useState({
    total: 0,
    count: 0,
    amount: 0,
    totalApp: 0,
    countApp: 0,
    amountApp: 0,
    totalWeb: 0,
    countWeb: 0,
    amountWeb: 0
  })
  const [uploadStatistic, setUploadStatistic] = useState({
    cartCount: 0,
    ticketCount: 0,
  })

  const getSummaryFunc = useCallback(async () => {
    const query = {
      phone: state.filter.phone || undefined,
      name: state.filter.name || undefined,
      cartId: state.filter.cartId || undefined,
      region: state.filter.region || undefined,
      gameId: state.filter.gameId || undefined,
    }

    if (isNewTab) {
      query.isDone = 0
      query.statusGroup = 'new'
    } else if (state.activeTab === 'waiting_result') {
      query.isDone = 1
      query.statusGroup = 'waiting_result'
      query.from = state.filter.from
      query.to = state.filter.to
    } else if (isHasResultTab) {
      query.isDone = 1
      query.statusGroup = 'has_result'
      query.from = state.filter.from
      query.to = state.filter.to
    } else if (state.filter.isDone === -1) {
      query.from = state.filter.from
      query.to = state.filter.to
    } else {
      query.isDone = state.filter.isDone
      if (state.filter.isDone === 1) {
        query.from = state.filter.from
        query.to = state.filter.to
      }
    }

    const response = await getSummary(cookies.lottmekong, query)

    if (response) {
      setSummary({
        count: response.count || 0,
        amount: response.amount || 0,
        total: response.total || 0,
        countApp: response.countApp || 0,
        amountApp: response.amountApp || 0,
        totalApp: response.totalApp || 0,
        countWeb: response.countWeb || 0,
        amountWeb: response.amountWeb || 0,
        totalWeb: response.totalWeb || 0
      })
    }
  }, [cookies.lottmekong, isNewTab, isHasResultTab, state.activeTab, state.filter.from, state.filter.to, state.filter.phone, state.filter.name, state.filter.cartId, state.filter.region, state.filter.gameId, state.filter.isDone])

  const getUploadStatisticFunc = useCallback(async () => {
    if (!isNewTab) {
      setUploadStatistic({
        cartCount: 0,
        ticketCount: 0,
      })
      return
    }

    const query = {
      phone: state.filter.phone || undefined,
      name: state.filter.name || undefined,
      cartId: state.filter.cartId || undefined,
      region: state.filter.region || undefined,
      gameId: state.filter.gameId || undefined,
    }

    const response = await getUploadStatistic(cookies.lottmekong, query)

    if (response) {
      setUploadStatistic({
        cartCount: response.cartCount || 0,
        ticketCount: response.ticketCount || 0,
      })
    }
  }, [cookies.lottmekong, isNewTab, state.filter.phone, state.filter.name, state.filter.cartId, state.filter.region, state.filter.gameId])

  useEffect(() => {
    getSummaryFunc()
    getUploadStatisticFunc()
  }, [getSummaryFunc, getUploadStatisticFunc, state.filterPressCount])

  const showAmount = !isNewTab && (isHasResultTab || state.activeTab === 'waiting_result' || state.filter.isDone === -1);

  return (
    <div className="d-flex gap-3">
      {isNewTab && (
        <div className="flex-fill">
          <StatCard
            title={`Cần úp ảnh (${uploadStatistic.ticketCount} vé)`}
            value={uploadStatistic.cartCount}
            variant="danger"
          />
        </div>
      )}
      <div className="flex-fill">
        <StatCard title="Tổng vé" value={summary.count} variant="primary" />
      </div>
      {showAmount && (
        <div className="flex-fill">
          <StatCard title="Tổng tờ" value={summary.amount} variant="info" />
        </div>
      )}
      <div className="flex-fill">
        <StatCard title="Tổng giá trị" value={parseInt(summary.total)} variant="success" isCurrency />
      </div>
    </div>
  );
};

export default React.memo(_Summary)
